import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import Discount from './components/Discount';

const SingleMode: FC = ({ mode, name }: any) => {
  const intl = useIntl();

  return (
    <React.Fragment>
      <div className="section-title">{intl.formatMessage({ id: 'paymentModes.singlePayment' })}</div>
      <Discount name={`${name}.discount`} discount={mode.discount}></Discount>
    </React.Fragment>
  );
};

export default SingleMode;
